module.exports = __webpack_public_path__ + "img/vrright.685a0d6a.png";